module.exports = __webpack_public_path__ + "img/placeholder.231733a9.png";